import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import Dropdown from "./../../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown";
import {authGoogleCalendar} from "../../../actions";
import {AccessRights} from "../../../schemas/accessRightsModel";

class CustomerAdditionalInfo extends React.Component {

  render() {

    const {intl, accountPageInfo} = this.props;
    const {entityId} = accountPageInfo;
    const defaultSelectValue = intl.formatMessage({id: 'select.defaultValue'});

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.customer_additional_info)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.customer_additional_info)}
                     title={intl.formatMessage({id: "account.additionalInfo.sectionTitle"})}>
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <div className="flex">
                <div className="new-account-col align-bottom">
                  <Dropdown id="vendorType" values={[defaultSelectValue]} activeValue=""
                            underlineText={intl.formatMessage({id: "account.additionalInfo.vendorType"})}
                            disabled={true} onChange={(value) => {}}/>
                </div>
                <div className="new-account-col edit-icon">
                  <div className="new-account-edit-icon"/>
                </div>
                <div className="new-account-col right">
                  <div className="new-account-text-box-wrapper dropdown">
                    <input id="vendorType" disabled={true}/>
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="new-account-col align-bottom">
                  <Dropdown id="repeatingDiscount" values={[defaultSelectValue]} activeValue=""
                            underlineText={intl.formatMessage({id: "account.additionalInfo.repeatingDiscount"})}
                            disabled={true} onChange={(value) => {}}/>
                </div>
                <div className="new-account-col edit-icon">
                  <div className="new-account-edit-icon"/>
                </div>
              </div>
              <div className="flex">
                <div className="new-account-col align-bottom">
                  <Dropdown id="pricingProfile" values={[defaultSelectValue]} activeValue=""
                            underlineText={intl.formatMessage({id: "account.additionalInfo.pricingProfile"})}
                            disabled={true} onChange={(value) => {}}/>
                </div>
                <div className="new-account-col edit-icon">
                  <div className="new-account-edit-icon"/>
                </div>
              </div>
            </div>
            <div className="acc-block">
              <div className="flex">
                <div className="new-account-col align-bottom">
                  <Dropdown id="salesPerson" values={[defaultSelectValue]} activeValue=""
                            underlineText={intl.formatMessage({id: "account.additionalInfo.salesPerson"})}
                            disabled={true} onChange={(value) => {}}/>
                </div>
                <div className="new-account-col edit-icon">
                  <div className="new-account-edit-icon"/>
                </div>
                <div className="new-account-col right">
                  <div className="new-account-text-box-wrapper dropdown">
                    <input id="salesPerson" disabled={true}/>
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="new-account-col align-bottom">
                  <Dropdown id="howDidYouHear" values={[defaultSelectValue]} activeValue=""
                            underlineText={intl.formatMessage({id: "account.additionalInfo.howDidYouHear"})}
                            disabled={true} onChange={(value) => {}}>
                  </Dropdown>
                </div>
                <div className="new-account-col edit-icon">
                  <div className="new-account-edit-icon"/>
                </div>
                <div className="new-account-col right">
                  <div className="new-account-text-box-wrapper dropdown">
                    <input id="howDidYouHear" disabled={true}/>
                  </div>
                </div>
              </div>
              {this.props.AR.isMe(entityId) ? (
                <div style={{marginTop: "18px"}}>
                  <button className="ui-button2 ui-button2--blue" onClick={() => authGoogleCalendar(entityId)}>
                    <FormattedMessage id="account.additionalInfo.calendarLinkButton"/>
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {accountPageInfo} = store.accountState;
  return {
    accountPageInfo,
    sectionsOpened: store.accountState.sectionsOpened,
    AR: AccessRights.get(store)
  };
};

const mapDispatchToProps = {
  toggleSectionOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CustomerAdditionalInfo)
);

